import SettingsPage from "@pages/SettingsPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getSettingsRoutes = (): AppRoute => ({
  path: paths.settings,
  protected: true,
  requiredPermissions: ["hasGatepassAccess"],
  element: <SettingsPage />,
});
